import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64a73984"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "components__rec-checkboxes-selector" }
const _hoisted_2 = { class: "causes-container" }
const _hoisted_3 = ["onUpdate:modelValue", "disabled"]
const _hoisted_4 = ["name", "value"]

import { recProps } from 'vue/applications/frontend/mixins/rec-component';
  import { themingCssClass } from 'vue/applications/frontend/mixins/theming-mixin';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'rec-checkboxes-selector',
  props: {...recProps()},
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", null, _toDisplayString(_ctx.description.description_text), 1),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.description.checkboxes, (score_item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "causes-entry",
          key: score_item.id
        }, [
          _createElementVNode("label", null, [
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": ($event: any) => ((score_item.checked) = $event),
                disabled: _ctx.description.disabled,
                class: _normalizeClass(_ctx.description.themed ? [_unref(themingCssClass)('normal'), 'themed'] : [])
              }, null, 10, _hoisted_3), [
                [_vModelCheckbox, score_item.checked]
              ])
            ]),
            _createElementVNode("div", null, _toDisplayString(score_item.label), 1)
          ]),
          (score_item.checked || score_item.initially_checked)
            ? (_openBlock(), _createElementBlock("input", {
                key: 0,
                type: "hidden",
                name: score_item.name,
                value: Number(score_item.checked)
              }, null, 8, _hoisted_4))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}
}

})